import { CSSProperties, FC, ReactNode } from 'react'
import { Tooltip } from 'antd'
import cn from './index.module.css'

interface ITooltipWrapper {
  title: string
  children: ReactNode
  className?: string
  style?: CSSProperties
  placement?:
    | 'left'
    | 'right'
    | 'bottom'
    | 'top'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom'
}

const TooltipWrapper: FC<ITooltipWrapper> = ({
  title,
  children,
  className,
  style,
  placement
}) => {
  return (
    <Tooltip
      style={style}
      className={className}
      title={title}
      overlayClassName={cn.tooltip}
      placement={placement}
    >
      <div></div>
      {children}
    </Tooltip>
  )
}

export default TooltipWrapper
